import React from 'react';
import getSeoData, { getCity } from '../../utils';
import BuyerList from './BuyerList';
import Layout from '../../components/Layout';
import NotFound from '../not-found/NotFound';
import { setCity } from '../../actions/city';
import { getCityConfig } from '../../apiUtils';
import { getBuyerArticlesData } from '../../actions/buyerList';
import { checkArticlesCity } from '../../utils/misc';

async function action({ fetch, pathname: path, store, params }) {
	const { cities, cityConfig, buyerList } = store.getState();

	const checkedCity = getCity(params.city, cities);

	if (!checkedCity)
		return {
			chunks: ['not-found'],
			title: 'Страница не найдена',
			component: (
				<Layout isNotFound>
					<NotFound title={this.title} />
				</Layout>
			),
			status: 404,
		};

	const city = setCity({
		store,
		params,
		fetch,
	});

	if (!cityConfig) {
		await getCityConfig(city.cityIds, {
			store,
			fetch,
		});
	}

	const { title, description, keywords } = await getSeoData(fetch, path, null, city.cityIds);

	const { articlesData: storedArticlesData, loading } = buyerList;

	const correctArticles = storedArticlesData && checkArticlesCity(storedArticlesData.items, city);

	if (!loading && (!storedArticlesData || correctArticles === false)) {
		await getBuyerArticlesData(0, 20)(store.dispatch, store.getState, {
			fetch,
		});
	}

	return {
		chunks: ['buyerList'],
		title,
		description,
		keywords,
		component: (
			<Layout route="expertise">
				<BuyerList />
			</Layout>
		),
	};
}

export default action;
